




import { defineComponent, reactive } from '@vue/composition-api';
import { EntityType } from '@/store/entityModules/types';
import EntityTable from '@/components/common/EntityTable.vue';

const Component = defineComponent({
  name: 'QuantityBreakTable',

  components: {
    EntityTable,
  },

  setup() {
    const entityType = EntityType.QUANTITY_BREAK;

    const state = reactive({
      headers: [
        { text: 'From', value: 'from', sortable: false },
        { text: 'To', value: 'to', sortable: false },
        { text: 'Edit', value: 'actions', align: 'right', sortable: false },
      ],
    });

    return {
      entityType,
      state,
    };
  },
});
export default Component;
